if (!customElements.get('lignon-scene-hotspots')) {
  customElements.define('lignon-scene-hotspots', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const close = (except) => this.querySelectorAll('details[open]').forEach(item => { if (item !== except) item.open = false; });
      this.querySelectorAll('details').forEach(item => {
        item.querySelector('summary').addEventListener('click', event => { if (event.pointerType === 'mouse' && item.open) event.preventDefault(); }, options);
        item.addEventListener('toggle', () => { if (item.open) close(item); }, options);
        item.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { clearTimeout(this.leaveTimer); close(item); item.open = true; } }, options);
        item.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !item.contains(document.activeElement)) this.leaveTimer = setTimeout(() => { item.open = false; }, 160); }, options);
      });
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { const item = event.target.closest('details'); close(); item?.querySelector('summary').focus(); event.preventDefault(); } }, options);
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.leaveTimer); }
  });
}
